import { Fragment, useCallback } from 'react';
import { Modal } from '@mui/material';
import { usePerformanceReportBuilderPageStore } from '@diana/core';
import { AdvancedEditorModalContent } from './AdvancedEditorModalContent';
import { FlowBuilderModalContentTypeEnum } from '../../FlowBuilder2Page/Store/FlowBuilder2PageStore.types';

export const ModalHub = () => {
  const activeModal = usePerformanceReportBuilderPageStore((s) => s.activeModal);
  const setActiveModal = usePerformanceReportBuilderPageStore((s) => s.setActiveModal);

  const onCloseModal = useCallback(() => {
    setActiveModal(null);
  }, [setActiveModal]);

  return (
    <Modal
      open={!!activeModal}
      onClose={(_, reason) => {
        if (reason === 'escapeKeyDown') return;
        onCloseModal();
      }}
    >
      {activeModal === FlowBuilderModalContentTypeEnum.AdvancedEditor ? (
        <AdvancedEditorModalContent onClose={onCloseModal} />
      ) : (
        <Fragment />
      )}
    </Modal>
  );
};
